<template>
  <b-nav-item-dropdown
    right
    @show="handleShowNotifications(false)"
  >
    <template v-slot:button-content>
      <SettingIcon :size="18" title="Configurações"></SettingIcon>
    </template>
    <b-dropdown-item href="/#/account/users">Usuários</b-dropdown-item>
    <b-dropdown-item href="/#/account/edit/">Dados da empresa</b-dropdown-item>
    <b-dropdown-item href="/#/account/accountant">Dados do contador</b-dropdown-item>
    <b-dropdown-item href="/#/account/configuration">Configurações</b-dropdown-item>
    <b-dropdown-item href="v2.html/#/payment">Assinatura</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import SettingIcon from 'vue-material-design-icons/Cog';

export default {
  name: 'NavbarConfigurations',
  props: ['handleShowNotifications'],
  components: {
    SettingIcon,
  },
};
</script>

<style scoped>
  .material-design-icon {
    font-size: 16px;
  }
</style>
